'use client'

import { useEffect, useState } from 'react'
import { PageViewTracker } from '@/components/cookies/page_view_tracker'
import { Cookies } from 'react-cookie-consent'
import { CookieBanner } from '@/components/cookies/cookie_banner'

export function CookieConsent({ children }: { children: React.ReactNode }) {
  
  const [hasConsent, setHasConsent] = useState(false)
  const [isCookieBannerVisible, setIsCookieBannerVisible] = useState(true)

  // On initial mount, check if the user has already consented.
  useEffect(() => {
    const consentCookie = Cookies.get("CookieConsent")
    if (consentCookie === "true") {
      setHasConsent(true)
      setIsCookieBannerVisible(false)
    } else if (consentCookie === "false") {
      setHasConsent(false)
      setIsCookieBannerVisible(false)
    }
  }, [])

  const handleConsentChange = (consent: boolean) => {
    setHasConsent(consent)
    setIsCookieBannerVisible(false)
  }

  return (
    <>
      <PageViewTracker hasConsent={hasConsent} />
      {children}
      {isCookieBannerVisible && <CookieBanner onConsentChange={handleConsentChange} />}
    </>
  )
}
